export enum InvoicePeriodizationDayOffset {
    TWO_DAYS = 2,
    FIVE_DAYS = 5,
    TEN_DAYS = 10,
    FIFTEEN_DAYS = 15,
}
